<div class="customer-form-page">
  <mat-card appearance="outlined" class="customer-form-card">
    @if (businessInfo$ | async; as businessInfo) {
      <form [formGroup]="form">
        <mat-card-content>
          @if (businessInfo.businessLogoUrl; as businessLogo) {
            <img class="business-logo" src="{{ businessLogo }}" />
          } @else {
            <div class="business-logo-container">
              <img src="{{ defaultLogoUrl }}" />
            </div>
          }
          <h3 mat-dialog-title>
            {{ 'CUSTOMER_FACING_FORM.TITLE' | translate }}
          </h3>
          <div class="description">
            {{ 'CUSTOMER_FACING_FORM.DESCRIPTION' | translate }}
          </div>
          <div class="name">
            <mat-form-field appearance="outline">
              <mat-label>
                {{ 'CUSTOMER_FACING_FORM.FIRST_NAME' | translate }}
              </mat-label>
              <input formControlName="firstName" matInput />
              @if (form.get('firstName').hasError('invalidName') && form.get('firstName').touched) {
                <mat-error>
                  {{ 'CUSTOMER_FACING_FORM.INVALID_FIRST_NAME' | translate }}
                </mat-error>
              }
              @if (form.get('firstName').hasError('nameTooLong') && form.get('firstName').touched) {
                <mat-error>
                  {{ 'CUSTOMER_FACING_FORM.FIRST_NAME_TOO_LONG' | translate }}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ 'CUSTOMER_FACING_FORM.LAST_NAME' | translate }}
              </mat-label>
              <input formControlName="lastName" matInput />
              @if (form.get('lastName').hasError('invalidName') && form.get('lastName').touched) {
                <mat-error>
                  {{ 'CUSTOMER_FACING_FORM.INVALID_LAST_NAME' | translate }}
                </mat-error>
              }
              @if (form.get('lastName').hasError('nameTooLong') && form.get('lastName').touched) {
                <mat-error>
                  {{ 'CUSTOMER_FACING_FORM.LAST_NAME_TOO_LONG' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline" class="field-with-hint">
            <mat-label>
              {{ 'CUSTOMER_FACING_FORM.EMAIL_ADDRESS' | translate }}
            </mat-label>
            <input
              [required]="businessInfo.templateType !== TEMPLATE_TYPE_SMS"
              formControlName="emailAddress"
              matInput
              />
            <mat-hint>
              {{
              (businessInfo.templateType !== TEMPLATE_TYPE_SMS
              ? 'CUSTOMER_FACING_FORM.REQUIRED'
              : 'CUSTOMER_FACING_FORM.OPTIONAL'
              ) | translate
              }}
            </mat-hint>
            @if (form.get('emailAddress').hasError('invalidEmail')) {
              <mat-error>
                {{ 'ADD_CUSTOMER_FORM.INVALID_EMAIL_ADDRESS' | translate }}
              </mat-error>
            }
            @if (form.get('emailAddress').hasError('required')) {
              <mat-error>
                {{ 'CUSTOMER_FACING_FORM.THIS_FIELD_REQUIRED' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="field-with-hint">
            <mat-label>
              {{ 'CUSTOMER_FACING_FORM.MOBILE' | translate }}
            </mat-label>
            <input
              [required]="businessInfo.templateType === TEMPLATE_TYPE_SMS"
              formControlName="phoneNumber"
              matInput
              />
            <mat-hint>
              {{
              (businessInfo.templateType === TEMPLATE_TYPE_SMS
              ? 'CUSTOMER_FACING_FORM.REQUIRED'
              : 'CUSTOMER_FACING_FORM.OPTIONAL'
              ) | translate
              }}
            </mat-hint>
            @if (form.get('phoneNumber').hasError('invalidPhoneNumber')) {
              <mat-error>
                {{ 'ADD_CUSTOMER_FORM.INVALID_PHONE_NUMBER' | translate }}
              </mat-error>
            }
            @if (form.get('phoneNumber').hasError('required')) {
              <mat-error>
                {{ 'CUSTOMER_FACING_FORM.THIS_FIELD_REQUIRED' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <div class="confirm-submit">
            <mat-checkbox
              [(ngModel)]="confirmationChecked"
              [ngModelOptions]="{ standalone: true }"
              color="primary"
            ></mat-checkbox>
            @if (businessInfo.businessName; as businessName) {
              <span>
                {{ 'CUSTOMER_FACING_FORM.CONFIRM_MESSAGE' | translate: { businessName: businessName } }}
              </span>
            } @else {
              <span>
                {{ 'CUSTOMER_FACING_FORM.CONFIRM_DEFAULT_MESSAGE' | translate }}
              </span>
            }
          </div>
        </mat-card-content>
        <mat-card-actions>
          <button
            (click)="submit()"
            [disabled]="!confirmationChecked || form.disabled"
            class="submit-button"
            color="primary"
            mat-raised-button
            >
            @if (!form.disabled) {
              {{ 'CUSTOMER_FACING_FORM.SUBMIT_BUTTON' | translate }}
            } @else {
              <mat-spinner diameter="24" strokeWidth="4"></mat-spinner>
            }
          </button>
        </mat-card-actions>
      </form>
    } @else {
      @if (loading$$ | async) {
        <div class="spinner-container">
          <div class="spinner-title">
            {{ 'CUSTOMER_FACING_FORM.LOADING' | translate }}
          </div>
          <mat-spinner diameter="40" strokeWidth="4"></mat-spinner>
        </div>
      } @else {
        <div class="error-container">
          <mat-icon class="error-icon">error_outline</mat-icon>
          <div class="error-title">
            {{ 'CUSTOMER_FACING_FORM.ERROR_LOADING_TITLE' | translate }}
          </div>
          <div class="error-description">
            {{ 'CUSTOMER_FACING_FORM.ERROR_LOADING_FORM' | translate }}
          </div>
        </div>
      }
    }
  </mat-card>
</div>
